import React from 'react'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import { ThemeProviderProps } from '@mui/material/styles/ThemeProvider'
import { DefaultTheme } from '@mui/styles/defaultTheme'
import { useMediaQuery } from '@mui/material'

import LightTheme from '@SonarCX/themes/LightTheme'
import { cloneDeep } from 'lodash'

const DynamicThemeProvider = (props: ThemeProviderProps<DefaultTheme>) => {
  const matches = useMediaQuery('@media (max-width:899.95px)')

  const theme = React.useMemo(() => {
    if (!matches) {
      return LightTheme
    }

    const copy = cloneDeep(LightTheme)
    copy.size = {
      xs: '0.625rem',
      sm: '0.75rem',
      base: '1rem',
      lg: '1.25rem',
      xl: '1.5rem',
      xxl: '1.75rem',
      xxxl: '2.75rem'
    }
    return copy
  }, [matches])

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme} {...props} />
    </StyledEngineProvider>
  )
}

export default DynamicThemeProvider
